import { deepMerge } from 'js/utils/Utils'

import BaseStage from 'js/webgl/base/BaseStage'

const defaults = {
  useComposer: false,
  fxParams: {
    threshold: 0,
    strength: 0,
    radius: 0,
    exposure: 0,
  },
}

export default class Stage extends BaseStage {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
    if (this.useComposer) {
      this._addGui()
    }
  }

  _setStageSize() {
    super._setStageSize()
  }

  _setPostFxMeshSize() {}

  onRender() {
    if (this.camera && this.camera.instance) {
      this.renderer.render(this.scene, this.camera.instance)
    }
  }

  _addGui() {}

  _removeGui() {}
}